var render = function render(){var _vm=this,_c=_vm._self._c;return _c('issue-card-statistics',{attrs:{"issue":_vm.issue}},[_c('blocking-issues-count',{staticClass:"gl-hidden @sm/panel:gl-inline-block",attrs:{"blocking-issues-count":_vm.issue.blockingCount,"is-list-item":"","data-testid":"blocking-issues"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }